import React, { useEffect, useRef } from 'react';
import { SCROLLSPEED } from "../../constants/constants";
import gsap from 'gsap';

const Parallax = ({
                    className,
                    children,
                    speed = 1,
                    id = 'parallax',
                    start = 'top center',
                    end = 'bottom top',
                    rotate = false,
                    rotateTo

}) => {
  const trigger = useRef();
  const target = useRef();
  const timeline = useRef();

  useEffect(() => {
    const y = 760 * speed * SCROLLSPEED;

    const setY = gsap.quickSetter(target.current, 'y', 'px');

    if (rotate) {
      timeline.current = gsap.timeline({
        scrollTrigger: {
          id,
          trigger: trigger.current,
          scrub: true,
          start,
          end,
          onUpdate: (e) => {
            setY(e.progress * y);
          }
        }
      }).to(target.current, {rotate: rotateTo, duration: 1.5});
    }  else {
      timeline.current = gsap.timeline({
        scrollTrigger: {
          id,
          trigger: trigger.current,
          scrub: true,
          start,
          end,
          onUpdate: (e) => {
            setY(e.progress * y);
          }
        }
      })
    }

    return () => {
      timeline?.current?.kill();
      trigger.current = null;
      target.current = null;
      timeline.current = null;
    }
  }, [id, speed]);

  return (
    <div ref={trigger} className={className}>
      <div ref={target}>{ children }</div>
    </div>
  );
}

export default Parallax;